import React from "react";
import { Link } from 'react-router-dom'

export default class ArtworkSide extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            users: [],
        };
        this.locatePosition.bind(this);
    }


    locatePosition(number) {
        let compare = "", ret = "";
        compare = String(number);
        if (compare[compare.length - 1] === '1') {
            if (compare.length > 1) {
                if (compare[compare.length - 2] === '1') {
                    ret = "th";
                } else {
                    ret = "st";
                }
            } else {
                ret = "st";
            }
        } else if (compare[compare.length - 1] === '2') {
            ret = "nd";
        } else if (compare[compare.length - 1] === '3') {
            ret = "rd";
        } else {
            ret = "th";
        }
        return ret;
    }


    componentDidMount() {
        fetch(process.env.REACT_APP_API_PATH + "/users", {
            method: "get",
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + sessionStorage.getItem("token")
            }
        })
            .then(res => res.json())
            .then(
                result => {
                    if (result) {
                        result[0].sort(function (a, b) {
                            return b.attributes.totalLikes - a.attributes.totalLikes;
                        })
                        this.setState({
                            users: result[0].slice(0, 6) || []
                        })
                    }
                }
            )
    }


    uploadHandler = event => {
        event.preventDefault()

        const formData = new FormData()
        const fileField = document.querySelector('input[type="file"]')

        formData.append('uploaderID', Number(sessionStorage.getItem("user")))
        formData.append('attributes', JSON.stringify({ postID: this.props.postID }))
        formData.append('file', fileField.files[0])

        fetch(process.env.REACT_APP_API_PATH + "/file-uploads", {
            method: "POST",
            headers: {
                'Authorization': 'Bearer ' + sessionStorage.getItem("token")
            },
            body: formData
        })
            .then(
                _ => {
                    window.location.reload()
                }
            )
    }


    render() {
        return (
            <div className="rightContentBox">

                { /* ------------------ UPLOAD IMAGE ------------------ */}
                <form className="artButton">
                    <label className="uploadImage">
                        <input type="file" accept="image/*" onChange={e => this.uploadHandler(e)} />
                        Upload Image
                    </label>
                </form>
                { /* -------------------------------------------------- */}

                <div className="leaderboardPreviewBox">
                    <div className="leaderboardPreviewTitle">
                        <input type="submit" value="Leaderboard" className="leaderboardPreviewTitleButton" />
                    </div>
                    <div className="leaderboardPreviewContent">
                        {this.state.users.map((user, index) => {
                            return (
                                <div className="leaderboardPreviewUser">
                                    <p className="leaderboardRank">
                                        {index + 1}{this.locatePosition(index + 1)}
                                    </p>
                                    <Link to={"/user/" + user.id} className="storypic">
                                        <img src={user.attributes.pfp}
                                            height='35'
                                            width='35'
                                            className='leaderBoradStoryPic'
                                            alt={user.attributes.username}
                                        />
                                    </Link>
                                    <p className="leaderboardUserName">
                                        {user.attributes.username}
                                    </p>
                                </div>
                            )
                        })}
                    </div>
                    <Link to="/leaderboard">
                        <input type="submit" value="View All" className="leaderboardPreviewViewAllButton" />
                    </Link>
                </div>
            </div>
        );
    }
}